/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { isChildOfContainerContext } from './flex-grid'
import { useMeta } from '../selectors'

const defaultModuleStyles = {
  mx: 'auto',
}

const spacingStyles = {
  spacingTop: 'marginTop',
  spacingBottom: 'marginBottom',
  spacingY: 'marginY',
}

const removeTopSpacingStyles = { mt: [0, 0, 0] }
const removeBottomSpacingStyles = { mb: [0, 0, 0] }

const getWrapperConfigStyles = ({ wrapperConfig, variant }) =>
  Object.entries(wrapperConfig).reduce((acc, [key, value]) => {
    if (spacingStyles[key]) {
      return { ...acc, [spacingStyles[key]]: value }
    }
    if (key === 'variants') {
      const variantConfig = value[variant]
      if (variantConfig) {
        Object.entries(variantConfig).forEach(([key1, value1]) => {
          if (spacingStyles[key1]) {
            acc = { ...acc, [spacingStyles[key1]]: value1 }
          }
        })
      }
    }
    acc = { ...acc, [key]: value }
    return acc
  }, {})

const getSpacingConfigStyles = ({ spacingConfig }) =>
  Object.entries(spacingConfig).reduce((acc, [key, value]) => {
    if (spacingStyles[key]) {
      return { ...acc, [spacingStyles[key]]: value }
    }
    return acc
  }, {})

export const ModuleContainer = ({
  children,
  spacing: spacingConfig = {},
  wrapperConfig = {},
  removeTopSpacing = false,
  removeBottomSpacing = false,
  variant,
  moduleSpacing = false,
  entryUseContainer,
}) => {
  const useContainerWrapper =
    wrapperConfig?.useContainer !== false &&
    wrapperConfig.variants?.[variant]?.useContainer !== false //check if useContainer wrapperConfig is specified to false
  const hasContainer =
    moduleSpacing === true &&
    (useContainerWrapper || entryUseContainer ? entryUseContainer !== false : false)
  const wrapperConfigStyles = getWrapperConfigStyles({ wrapperConfig, variant })
  const spacing = getSpacingConfigStyles({ spacingConfig })
  const interModuleSpacing = useMeta(['interModuleSpacing'], undefined) ?? 'xxl'

  const sx = {
    ...defaultModuleStyles,
    ...(moduleSpacing ? { my: interModuleSpacing } : { my: 'sm' }),
    ...(hasContainer ? { variant: 'container.moduleContainer' } : {}),
    ...wrapperConfigStyles,
    ...spacing,
    ...(removeTopSpacing ? removeTopSpacingStyles : {}),
    ...(removeBottomSpacing ? removeBottomSpacingStyles : {}),
  }

  return (
    <div sx={sx}>
      <isChildOfContainerContext.Provider value={hasContainer}>
        {children}
      </isChildOfContainerContext.Provider>
    </div>
  )
}
